import * as React from 'react';
import { faItalic } from '@fortawesome/pro-regular-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { useLocalization } from '~/framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ItalicButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleItalic().run()}
         isActive={editor.isActive('italic')}
         isDisabled={!editor.can().toggleItalic()}
         icon={<FontAwesomeIcon icon={faItalic} />}
         title={_js('Italic')}
         shortcut={'i'}
      ></TiptapButton>
   );
};
